import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import OurProcessSection from '../Components/recruiting/OurProcessSection'
import FAQSection from '../Components/recruiting/FAQSection'
import FindingRightFitSection from '../Components/recruiting/FindingRightFitSection'
import HiringProcessFAQ from '../Components/recruiting/HiringProcessFAQ'
import TechnicalAssessment from '../Components/recruiting/TechnicalAssessment'
import { Helmet } from "react-helmet-async";

function Recruiting() {
    return (
        <div>
            <Helmet>
    <title>
        Recruiting at Mobikode | Hiring Process & Opportunities
    </title>

    <meta
        name="description"
        content="Learn about recruiting at Mobikode, our hiring process, technical assessments, candidate evaluation, and how we find the right talent to build our technology teams."
    />

    <meta
        name="keywords"
        content="Mobikode Recruiting, Recruiting at Mobikode, Mobikode Hiring, Mobikode Careers, Hiring Process, Recruitment Process, Technical Assessment, Candidate Assessment, IT Recruitment, Technology Hiring, Software Developer Hiring, Job Opportunities, Mobikode Jobs"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/recruiting"
    />

    <meta
        property="og:title"
        content="Recruiting at Mobikode | Hiring Process & Opportunities"
    />

    <meta
        property="og:description"
        content="Discover how Mobikode approaches recruiting, from finding the right fit and technical assessments to our hiring process and candidate experience."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/recruiting"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/recruiting/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Recruiting at Mobikode | Hiring Process & Opportunities"
    />

    <meta
        name="twitter:description"
        content="Learn about Mobikode's recruitment process, technical assessments, candidate evaluation, and approach to finding the right talent."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/recruiting/bg1.png"
    />
</Helmet>
            <WhoHero
                title="About recruiting at Mobikode"
                text="Technology. Transformation. Trust."
                imgData="/assets/recruiting/bg1.png"
            />
            <OurProcessSection />
            <FAQSection />
            <FindingRightFitSection />
            <HiringProcessFAQ />
            <TechnicalAssessment />
        </div>
    )
}

export default Recruiting
